// extracted by css-extract-rspack-plugin
export default {"content":"_2ifqe4w7S9c4tXcpHwGv4p","betaBanner":"_3Y162oQ5dHwgR04a60EXdg","header":"_3nGC5mIkZkmrJAxgAe0Yf_","developerTitle":"_3SxfRQ_pweVsIrvsUTdlij"};